import React, { useState, useContext } from "react";
import { FileUploader } from "react-drag-drop-files";
import "../../assets/styles/smu-file-uploader.scss";
import { IconUpload } from "../../icons/Icon";
import { COLOR_PRIMARY } from "../../constants/colors";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import loadingGif from "../../assets/images/loading.gif";
import { prepareText } from "../../helpers";
import { StoreContext } from "../../store/StoreContext";


const brand = process.env.REACT_APP_BRAND || "S10";

const SmuFileUploader = (props) => {
  const { uploadFile, acceptedTypes, files, setFiles, label, multiple, needPromo = false, verifyPrefix=false, autoClean = true, blockButtons = false } =
    props;
  const handleLabel = label || `Cargar ${!multiple ? "archivo" : "archivos"}`;

  const [loading, setLoading] = useState(false);
  const { promotions } = useContext(StoreContext);


  const handleUploadFile = () => {

    let loadFiles = true;
    let promoFile = true;
    let errorFile = "";
      try {
        files.forEach(file => {
          let nameSplitOne = file.name.split("-")[0];
          let nameSplitTwo = file.name.split("_")[0];
          if (nameSplitOne != brand && nameSplitTwo != brand) {
            loadFiles = false;
            errorFile = file.name;
            throw new Error(`El archivo "${file.name}" no corresponde a este formato.`);
          }

          let _promo = promotions.find((p) => {
            const description = prepareText(p.DESCRIPCION_PROMO);
            const _promotionName = prepareText(file.name);
            return _promotionName.includes(description);
          });

          if (!_promo){
            promoFile = false;
            errorFile = file.name;
            throw new Error(`El archivo "${file.name}" no se pudo asociar a una promocion.`);
          }
        });
      } catch (err) {
        errorFile = errorFile || (files.length > 0 ? files[0].name : "");
        // Raise the error file for further handling
        //throw err;
      }
    
    if(!loadFiles && verifyPrefix) 
      return toast({
        icon: "error",
        title: `El archivo "${errorFile}" no corresponde a este formato.`,
      });

    // Deprecated - now validation is in backend (for skirt)
    if(!promoFile && needPromo) 
      return toast({
        icon: "error",
        title: `El archivo "${errorFile}" no se pudo asociar a una promocion.`,
      });  
    
   
      setLoading(true);
      uploadFile()
        .then((result) => {
          if (result?.error) throw new Error("No fue posible cargar el archivo.");
          if (multiple != true && result?.type != 'faldon') 
            toast({ icon: "success", title: "Carga exitosa." });
        })
        .catch((err) => {
          setLoading(false);
          console.error(err);//console.error(err);//toast({ icon: "error", title: err });
        })
        .finally(() => {
          setLoading(false);
          if (autoClean) {
            setFiles([]);
          }
        });
    

  };

  const onChange = (_files) => {
    const __files = multiple ? Array.from(_files) : [_files];
    setFiles(__files);
  };

  return (
    <>
      <FileUploader
        label={handleLabel}
        handleChange={(_files) => onChange(_files)}
        classes="load-area"
        name="file"
        types={acceptedTypes}
        multiple={Boolean(multiple)}
      >
        <div className="file-button px-4 py-1 d-flex align-items-center">
          <IconUpload color="#6F767E" />
          <span className="mt-1">{handleLabel}</span>
        </div>
      </FileUploader>

      <ul>
        {files.map((file) => (
          <li key={file.name} className="mb-1">{file.name}</li>
        ))}
      </ul>

      <div
        className={`${
          files?.length > 0 ? "d-flex" : "d-none"
        } align-items-center `}
        style={{ flexWrap: "wrap" }}
      >
        <button
          type="button"
          className="smu-generic-button px-3 border-secondary text-secondary"
          onClick={() => setFiles([])}
          disabled={blockButtons}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="smu-generic-button px-3 ms-3 d-flex align-items-center"
          onClick={() => handleUploadFile()}
          style={{ width: 165 }}
          disabled={loading || blockButtons}
        >
          {!loading ? (
            <>
              <IconUpload color={COLOR_PRIMARY} />
              <span className="ms-1">
                Subir {!multiple ? "archivo" : "archivos"}
              </span>
            </>
          ) : (
            <>
              <span className="ms-1 me-auto">Cargando...</span>
              <img src={loadingGif} alt="Cargando..." height="20" />
            </>
          )}
        </button>
      </div>
    </>
  );
};

export default SmuFileUploader;
